import { MaintenanceForwardingsRequiredDirectiveStepsData } from "./maintenanceForwardingsShowDirectiveDetails.type";

export enum MaintenanceForwardingsDirectiveFormStepState {
  Pending = 'pending',
  Current = 'current',
  Completed = 'completed',
}

export type MaintenanceForwardingsDirectiveFormStepProps<K extends keyof MaintenanceForwardingsRequiredDirectiveStepsData> = {
  stepIndex: number;
  state: MaintenanceForwardingsDirectiveFormStepState;
  attributes: MaintenanceForwardingsRequiredDirectiveStepsData[K] | undefined;
}
